// ROUTES
export const ROUTE_LIST = 'admin2.payor.list';
export const ROUTE_CREATE = 'admin2.payor.create';
export const ROUTE_UPDATE = 'admin2.payor.update';

// CLAIMS
export const CLAIM_PAYOR_EDIT = 'admin.payor.edit';

// STORAGE KEYS
export const PAYOR_LIST_STORAGE_KEY = 'admin-payor-list';
export const PAYOR_LIST_VIEW_KEY = 'tv-admin-payor-list';

// DATA TYPES
export const PAYOR_MED_TYPE_MANAGED = 'MANAGED';
export const PAYOR_MED_TYPE_MEDICAID = 'MEDICAID';
export const PAYOR_STATUS_ACTIVE = 'ACTIVE';
export const PAYOR_STATUS_INACTIVE = 'INACTIVE';
